<script setup lang="ts">
import type {Media} from '~/types/legacy'
import {resolveMediaProps} from '~/utils/relations'
// oxlint-disable-next-line import/no-unassigned-import
import 'swiper/css'
import {Swiper, SwiperSlide} from 'swiper/vue'

interface ImageGridItem {
  image: number | Media
  id?: string | null
}

const props = defineProps<{
  items: ImageGridItem[]
  first?: boolean
}>()
</script>

<template>
  <div v-if="items.length" class="relative z-0 justify-center gap-4">
    <swiper
      class="!overflow-visible"
      :initialSlide="props.first ? 4 : 6"
      slidesPerView="auto"
      grabCursor
      centeredSlides
    >
      <swiper-slide
        v-for="(item, i) in props.items"
        :key="item.id ?? i"
        :index="i"
        :style="{height: 'auto !important', width: 'auto !important'}"
        class="mr-8"
      >
        <NuxtImg
          v-bind="resolveMediaProps(item.image)"
          fit="cover"
          class="h-64 max-h-72 w-auto rounded-lg object-cover transition-all md:max-h-96 lg:max-h-[36rem]"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>
